var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"page"},[_c('div',{staticClass:"page__bd"},[_c('div',{staticClass:"weui-gallery"},[_c('img',{staticClass:"weui-gallery__img",attrs:{"crossorigin":"anonymous","src":_vm.cardUrl,"id":"weui-gallery__img"}}),_c('div',{staticClass:"weui-gallery__tip"},[_vm._v("长按图片分享")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }